import React from 'react';
import {Plugins, withMeta, withSystem, Atom} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  typeName,
  pluginName,
} from '@packages/systems/wfdl-Qualified';

import {TTypeConstructor, TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const pageBuildingPlugin = Plugins.name('PageBuilding');

const DropTarget = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const Tag = data.tag ?? 'div';
    return (
      <Tag {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createIntegratedAtom({
  showEmpty: true,
  icon: {
    type: 'Component',
    value: [pageBuildingPlugin, iconName('PageSlotIcon')],
  },
  constraints: {
    ancestors: [
      {
        is: [
          'Body',
          'Container',
          'BlockContainer',
          'Section',
          'VFlex',
          'HFlex',
          'Layout',
          'Cell',
          'Block',
          'List',
          'ListItem',
          'SliderWrapper',
          'SliderSlide',
          'SliderMask',
          'DropdownWrapper',
          'DropdownList',
          'DropdownLink',
          'TabsWrapper',
          'TabsLink',
          'TabsPane',
          'TabsMenu',
          'TabsContent',
          'Grid',
          'Row',
          'Column',
          'Optimization',
          'OptimizationExperience',
          'OptimizationTreatment',
          'OptimizationBase',
        ],
        rule: 'RequireOnly',
        name: 'Element',
      },
    ],
  },
  displayName: 'Page Slot',
  render: DropTarget,
  fields: {
    children: withSystem({private: true}, TListOfElement),
    tag: withMeta(
      {variant: 'menu'},
      withSystem(
        {
          defaultValue: 'div',
          label: 'Tag',
          private: true,
          isLocalizable: true,
        },
        TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
      )
    ),
  },
});

export default config;
